//@config
export default {
  cooperation: {
    order: "v1/order",
    order_id: "v1/order/{0}",
    payment_rule: "v1/payment_rule",
    payment_rule_id: "v1/payment_rule/{0}",
    payment_rule_parvandeh: "v1/payment_rule_parvandeh",
    parvandeh_payment_cooperation: "v1/parvandeh/{0}/payment_cooperation",
    payment_cooperation: "v1/payment_cooperation",
    payment_cooperation_id: "v1/payment_cooperation/{0}",
    order_report_id: "v1/order_report/{0}",
    financial_report: "v1/financial_report/{0}",
    dailyWorking: "v1/daily_working",
    dailyWorkingByCode: "v1/daily_working/{0}",
  },
};
